import type { HistoryStep } from 'src/redux/slices/Interview/types';
import type { AnswerPayload } from 'src/redux/slices/Interview/hooks';
import { makeStepKey } from 'src/redux/slices/Interview/stepKey';

export function buildAnswerPayload(
  surveyId: number,
  qitId: number,
  questionType: string,
  answerGroupId: number | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  effectiveValue: any
): AnswerPayload {
  const payload: AnswerPayload = {
    surveyId,
    qitId,
    answerGroupId,
  };
  if (['bool', 'choices', 'frequency'].includes(questionType)) {
    payload.questionChoices = [effectiveValue];
  } else if (questionType === 'multiselect') {
    payload.questionChoices = effectiveValue;
  } else if (questionType === 'text_area') {
    payload.textArea = effectiveValue;
  } else if (questionType === 'percentage') {
    const numVal = parseFloat(
      String(effectiveValue ?? '0').replace(/[%\s]/g, '')
    );
    payload.text = String(numVal / 100);
  } else if (questionType === 'currency') {
    payload.text = String(effectiveValue ?? '').replace(/[^\d.-]/g, '');
  } else {
    payload.text = String(effectiveValue ?? '');
  }
  return payload;
}

export function isSameInstance(a: HistoryStep, b: HistoryStep): boolean {
  return (
    a.kind === 'question' &&
    b.kind === 'question' &&
    a.groupId === b.groupId &&
    a.answerGroupId === b.answerGroupId &&
    a.instanceSeq === b.instanceSeq
  );
}

export function buildInstanceAnswersMap(
  history: HistoryStep[],
  answersByKey: Record<string, unknown>,
  groupId: number | null,
  answerGroupId: number | null,
  instanceSeq: number
): Record<number, unknown> {
  const map: Record<number, unknown> = {};
  for (const step of history) {
    if (
      step.kind === 'question' &&
      step.groupId === groupId &&
      step.answerGroupId === answerGroupId &&
      step.instanceSeq === instanceSeq &&
      step.qitId != null
    ) {
      const key = makeStepKey(step);
      if (key in answersByKey) {
        map[step.qitId] = answersByKey[key];
      }
    }
  }
  return map;
}

export function isSameGroup(a: HistoryStep, b: HistoryStep): boolean {
  return (
    a.kind === 'question' &&
    b.kind === 'question' &&
    a.groupId != null &&
    a.groupId === b.groupId
  );
}

export function deepEqual(a: unknown, b: unknown): boolean {
  return JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
}
